import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import { throttle } from "lodash";
import rootReducer from "./_reducers";
import wsMiddleware from "../src/_middleware/middleware";
import * as Sentry from "@sentry/react";
import { HYDRATE } from "./_actions/types";

const storeLocalStorageKey = "store";

const loadStore = () => {
  try {
    const serializedStore = localStorage.getItem(storeLocalStorageKey);
    if (serializedStore === null) {
      return undefined;
    }
    return JSON.parse(serializedStore);
  } catch (err) {
    return undefined;
  }
};

const saveStore = (store) => {
  const serializedStore = JSON.stringify(store);

  try {
    localStorage.setItem(storeLocalStorageKey, serializedStore);
  } catch (err) { }
};

export const clearPersistedStore = () => {
  try {
    localStorage.removeItem(storeLocalStorageKey);
  } catch (err) { }
};

const persistedStore = loadStore();

// Create the middleware instance.
//const reduxWebsocketMiddleware = reduxWebsocket({ prefix: WEBSOCKET_PREFIX });

const middleware = [thunk, wsMiddleware];

const composeEnhancers =
  typeof window === "object" &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
  process.env.REACT_APP_DEBUG === "True"
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
        trace: true,
        traceLimit: 25,
      })
    : compose;

const sentryReduxEnhancer = Sentry.createReduxEnhancer({});

const enhancer = composeEnhancers(
  applyMiddleware(...middleware),
  sentryReduxEnhancer
  // other store enhancers if any
);
const store = createStore(rootReducer, persistedStore, enhancer);

// @NOTE use for merging part of persisted state with initialState
store.dispatch({ type: HYDRATE });

export const { dispatch, getState } = store;

export function getSelectors(processor) {
  return processor(getState());
}

export const savePersistedStore = () => {
  saveStore({
    socialAccountsStore: store.getState().socialAccountsStore,
    plannerStore: {
      eventsCategories: store.getState().plannerStore.eventsCategories,
    },
    analyticsStore: {
      selectedMetrics: store.getState().analyticsStore.selectedMetrics,
      charts: store.getState().analyticsStore.charts,
    },
    auth: store.getState().auth,
  });
};

// throttle saving of persisted store to avoid doing it too often
store.subscribe(
  throttle(() => {
    savePersistedStore();
  }, 1000)
);

export default store;

// selectors
export const getStore = (state) => state;

// editor
export const getEditor = (state) => getStore(state).editor;
